<div [formGroup]="form">
  <mtn-text-field
    [form]="form"
    controlName="confirmation"
    [placeholder]="'FORM.CONFIRM' | translate"
    [isRequired]="true">
  </mtn-text-field>
</div>
